import { render, staticRenderFns } from "./rfq-statewide-add-parts.vue?vue&type=template&id=298f143a&scoped=true"
import script from "./rfq-statewide-add-parts.vue?vue&type=script&lang=js"
export * from "./rfq-statewide-add-parts.vue?vue&type=script&lang=js"
import style0 from "./rfq-statewide-add-parts.vue?vue&type=style&index=0&id=298f143a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f143a",
  null
  
)

export default component.exports